if (!customElements.get('shop-the-look')) {
  class ShopTheLook extends HTMLElement {
    constructor() {
      super();
      this.canvas = this.querySelector('[data-stl-canvas]');
      this.dots = this.querySelectorAll('[data-stl-dot]');
      this.overlay = this.querySelector('[data-stl-overlay]');
      this.sheet = this.querySelector('[data-stl-sheet]');
      this.activeId = null;
    }

    connectedCallback() {
      this.dots.forEach(dot => dot.addEventListener('click', this.handleDotClick));
      document.addEventListener('click', this.handleDocClick);
      this.overlay?.addEventListener('click', this.closeAll);
      this.querySelectorAll('[data-stl-close]')?.forEach(btn => btn.addEventListener('click', this.closeAll));
    }

    // Decide tooltip placement relative to the dot inside the canvas
    applyPlacement(dot, tooltip) {
      const canvas = this.canvas || this;
      const canvasRect = canvas.getBoundingClientRect();
      const dotRect = dot.getBoundingClientRect();
      // Temporarily show to measure size
      tooltip.style.visibility = 'hidden';
      tooltip.classList.add('open');
      const tipRect = tooltip.getBoundingClientRect();
      tooltip.classList.remove('open');
      tooltip.style.visibility = '';

      const spaceLeft = dotRect.left - canvasRect.left;
      const spaceRight = canvasRect.right - dotRect.right;
      const spaceTop = dotRect.top - canvasRect.top;
      const spaceBottom = canvasRect.bottom - dotRect.bottom;

      tooltip.classList.remove('place-left','place-right','place-top','place-bottom');

      const needHoriz = Math.max(tipRect.width || 280, 280);
      const needVert = Math.max(tipRect.height || 160, 160);

      if (spaceRight >= needHoriz) {
        tooltip.classList.add('place-right');
        return;
      }
      if (spaceLeft >= needHoriz) {
        tooltip.classList.add('place-left');
        return;
      }
      if (spaceTop >= needVert) {
        tooltip.classList.add('place-top');
        return;
      }
      tooltip.classList.add('place-bottom');
    }

    disconnectedCallback() {
      this.dots.forEach(dot => dot.removeEventListener('click', this.handleDotClick));
      document.removeEventListener('click', this.handleDocClick);
      this.overlay?.removeEventListener('click', this.closeAll);
      this.querySelectorAll('[data-stl-close]')?.forEach(btn => btn.removeEventListener('click', this.closeAll));
    }

    closeAll = () => {
      this.activeId = null;
      this.querySelectorAll('[data-stl-tooltip]').forEach(t => t.classList.remove('open'));
      this.sheet?.classList.remove('open');
      this.overlay?.classList.remove('open');
      this.dots.forEach(d => d.classList.remove('active'));
    }

    handleDotClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      const dot = e.currentTarget;
      const id = dot.getAttribute('data-stl-target');
      if (!id) return;

      const tooltip = this.querySelector(`[data-stl-tooltip][data-stl-id='${id}']`);
      const isMobile = window.matchMedia('(max-width: 767px)').matches;

      // Close others
      this.closeAll();

      // Open this
      dot.classList.add('active');
      this.activeId = id;

      if (isMobile) {
        const sheetContent = this.querySelector(`[data-stl-sheet-content][data-stl-id='${id}']`);
        if (!sheetContent) return;
        // Move content to sheet body for current selection
        const body = this.querySelector('[data-stl-sheet-body]');
        if (body) {
          body.innerHTML = '';
          const fragment = sheetContent.tagName === 'TEMPLATE'
            ? sheetContent.content.cloneNode(true)
            : sheetContent.cloneNode(true);
          body.appendChild(fragment);
        }
        this.sheet?.classList.add('open');
        this.overlay?.classList.add('open');
      } else if (tooltip) {
        // Auto placement based on viewport and hotspot position
        this.applyPlacement(dot, tooltip);
        tooltip.classList.add('open');
      }
    }

    handleDocClick = (e) => { 
      if (!this.contains(e.target)) {
        this.closeAll();
      }
    }
  }
  customElements.define('shop-the-look', ShopTheLook);
}


